var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RestClient } from '@pegasus/rest-client';
export var getTopPicks = function (queryParams) {
    return RestClient.get("/api/phoenix/search/top-picks/articles")
        .withClientType('web')
        .withQueryParameters(__assign({ page: 0, personalized: true, size: 10 }, queryParams))
        .withHeaders({
        'X-Touchpoint': 'tp4u-carousel',
    })
        .acceptStatusCodes([200, 206])
        .send()
        .then(function (req) { return req.json(); });
};
